export class SpectralResult {
    constructor(warnings, errors, spectralIssues) {
        this.warnings = warnings;
        this.errors = errors;
        this.spectralIssues = spectralIssues;
    }
}
//# sourceMappingURL=spectral.result.js.map